@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    display: grid;
    grid-template-columns: 45% 55%;
    min-height: 100vh;
    padding: 1rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;

        & > div:nth-of-type(2) {
            display: none;
        }
    }

    & img {
        border: 1px solid rgb(var(--color-black-base), 0.25);
        max-width: 100%;
    }
}

.heading {
    font-size: 1.75rem;
    line-height: 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        text-align: center;
    }
}

.address {
    font-size: 1.375rem;
    font-style: normal;
    line-height: 1;
    margin-top: 1.25rem;
    margin-bottom: 1rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        text-align: center;
    }
}

.contactUs {
    composes: address;
}

.phoneNumber {
    composes: address;
    margin-bottom: 1.5rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        justify-content: center;
    }
}

.button {
    composes: roundButton from "../../styles/buttons.module.scss";

    @include breakpoint.breakpoint(layout.$belowMedium) {
        // Adding !important to bust through CSS Module composes weirdness
        display: block !important;
    }
}

.mobileMap {
    @include breakpoint.breakpoint(layout.$aboveMedium) {
        display: none;
    }
}

.findLocationLink {
    color: var(--color-lobster);
    display: block;
    margin-top: 0.5rem;
    text-align: right;
    text-decoration: none;
    text-transform: uppercase;

    &::before {
        background-color: var(--color-lobster);
        content: "";
        display: inline-block;
        height: 14px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 384 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 14px 14px;
        min-width: 14px;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        text-align: center;
    }
}
